import { useState, useEffect, useRef } from "react";
import { API_BASE } from "../constants/gameConstants";

export default function WordDefinitionModal({ word, onClose }) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const canCloseRef = useRef(false);

  // Guard against the touch→click sequence closing the modal immediately after opening
  useEffect(() => {
    const t = setTimeout(() => { canCloseRef.current = true; }, 300);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    fetch(`${API_BASE}/get-definition?word=${encodeURIComponent(word.toLowerCase())}`)
      .then(r => r.json())
      .then(json => {
        if (json.ok) setData(json);
        else setError(json.error || "No definition found");
      })
      .catch(e => setError(`Error: ${e.message}`))
      .finally(() => setIsLoading(false));
  }, [word]);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={() => { if (canCloseRef.current) onClose(); }}
    >
      <div
        className="w-full max-w-md rounded-2xl shadow-2xl p-6 max-h-[80vh] overflow-y-auto"
        style={{ background: "rgba(30, 20, 50, 0.97)" }}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-between items-start mb-4">
          <div>
            <h2 className="text-3xl font-extrabold text-white tracking-wide">
              {word.toUpperCase()}
            </h2>
          </div>
          <button
            onClick={() => { if (canCloseRef.current) onClose(); }}
            className="text-purple-300 hover:text-white text-2xl leading-none ml-4"
          >
            ✕
          </button>
        </div>

        {isLoading && (
          <div className="flex justify-center py-8">
            <div className="w-8 h-8 border-4 border-purple-400 border-t-transparent rounded-full animate-spin" />
          </div>
        )}

        {error && (
          <div className="text-center py-4">
            <p className="text-purple-300 mb-4">No definition found</p>
            <a
              href={`https://www.google.com/search?q=define+${encodeURIComponent(word.toLowerCase())}`}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-purple-600 text-white rounded-lg font-semibold hover:bg-purple-700 transition text-sm"
            >
              Search Google →
            </a>
          </div>
        )}

        {data?.definition && (
          <div>
            {data.pos && <p className="text-purple-400 font-semibold italic mb-2">{data.pos}</p>}
            <p className="text-white text-sm">{data.definition}</p>
          </div>
        )}
      </div>
    </div>
  );
}
